import i18n from 'i18next';
import _sortBy from 'lodash/sortBy';
import { resetCutSectionId } from 'redux/modules/flag';
import { setSuccess, setFailed } from 'redux/modules/notify';
import { updateGlobalSectionData } from 'api/editor';

export const REPLACE_SECTIONS = 'REPLACE_SECTIONS';
export const ADD_SECTION = 'ADD_SECTION';
const ADD_GlobalSection_SECTION = 'ADD_GlobalSection_SECTION';
export const UPDATE_SECTION_TYPE = 'UPDATE_SECTION_TYPE';
export const DELETE_SECTION = 'DELETE_SECTION';
const CONVERT_COMMON_SECTION = 'CONVERT_COMMON_SECTION';
export const UPDATE_TEMPID_SECTION = 'UPDATE_TEMPID_SECTION';
export const CONVERT_GlobalSection_SECTION = 'CONVERT_GlobalSection_SECTION';
const FORCE_DELETE_SECTION = 'FORCE_DELETE_SECTION';
const ADD_MOVE_FLAG = 'ADD_MOVE_FLAG';

export default function sections(state = [], action) {
    switch (action.type) {
        case REPLACE_SECTIONS:
            return action.payload;
        case ADD_SECTION: {
            const { section, selectPageId, selectIndex } = action.payload;
            const newPageSections = mergeSelectPageSections({
                state,
                selectIndex,
                selectPageId,
                section
            });

            const otherPagesSections = state.filter(section => section.pageId !== selectPageId);
            return [...newPageSections, ...otherPagesSections];
        }
        case ADD_GlobalSection_SECTION: {
            const { sections, selectPageId, selectIndex } = action.payload;
            const newPageSections = mergeSelectPageSectionsList({
                state,
                selectIndex,
                selectPageId,
                sections
            });
            const clearDuplicateSection = newPageSections
                .filter(
                    section =>
                        !sections.find(newData => section.id === newData.id && section.deleted)
                )
                .map((section, index) => {
                    return { ...section, seq: index + 1 };
                });
            const otherPagesSections = state.filter(section => section.pageId !== selectPageId);
            return [...clearDuplicateSection, ...otherPagesSections];
        }
        case UPDATE_SECTION_TYPE: {
            const { selectId, newType } = action.payload;
            return state.map(value => {
                if (value.id === selectId) {
                    return { ...value, type: newType };
                }
                return value;
            });
        }
        case DELETE_SECTION: {
            const { sectionId } = action.payload;
            const { pageId: selectPageId } = state.find(section => section.id === sectionId);
            const pageSections = getPageSections(state, selectPageId);
            const deleteSections = pageSections.reduce((currentArray, section) => {
                if (section.id === sectionId) {
                    currentArray.push({ ...section, deleted: 1 });
                    return currentArray;
                }
                currentArray.push({
                    ...section,
                    seq:
                        currentArray.length +
                        1 -
                        currentArray.reduce(
                            (sum, section) => (sum += Number(section.deleted === 1)),
                            0
                        )
                });
                return currentArray;
            }, []);
            const otherSections = state.filter(section => section.pageId !== selectPageId);
            return [...deleteSections, ...otherSections];
        }
        case FORCE_DELETE_SECTION: {
            const { sectionId } = action.payload;
            const { pageId: selectPageId } = state.find(section => section.id === sectionId);
            const pageSections = getPageSections(state, selectPageId);
            const deleteSections = pageSections.reduce((currentArray, section) => {
                if (section.id === sectionId) {
                    return currentArray;
                }
                currentArray.push({
                    ...section,
                    seq:
                        currentArray.length +
                        1 -
                        currentArray.reduce(
                            (sum, section) => (sum += Number(section.deleted === 1)),
                            0
                        )
                });
                return currentArray;
            }, []);
            const otherSections = state.filter(section => section.pageId !== selectPageId);
            return [...deleteSections, ...otherSections];
        }
        case UPDATE_TEMPID_SECTION: {
            const { mapPages, mapSections } = action.payload;
            const sectionsReplaceTemp = state.map(section => {
                let newSection = section;
                if (mapSections[section.id]) {
                    newSection = { ...newSection, id: mapSections[section.id] };
                }
                if (mapPages[section.pageId]) {
                    newSection = { ...newSection, pageId: mapPages[section.pageId] };
                }
                return newSection;
            });
            return sectionsReplaceTemp;
        }
        case CONVERT_COMMON_SECTION: {
            const { sectionId } = action.payload;
            const newState = state.map(section => {
                if (sectionId === section.id) {
                    return {
                        ...section,
                        globalSectionId: null,
                        globalSectionName: null
                    };
                }
                return section;
            });

            return newState;
        }
        case CONVERT_GlobalSection_SECTION: {
            const { sectionId, globalSectionId, globalSectionName } = action.payload;
            const newState = state.map(section => {
                if (sectionId === section.id) {
                    return {
                        ...section,
                        globalSectionId,
                        globalSectionName
                    };
                }
                return section;
            });
            return newState;
        }
        case ADD_MOVE_FLAG: {
            const { sectionId, pageId } = action.payload;
            const newState = state.map(section => {
                if (sectionId === section.id && !section.pageIdOrigin) {
                    return {
                        ...section,
                        pageIdOrigin: pageId
                    };
                }
                return section;
            });
            return newState;
        }
        default:
            return state;
    }
}

function mergeSelectPageSections({ state, selectIndex, selectPageId, section }) {
    const { id, type, pageIdOrigin, globalSectionId, globalSectionName, deleted } = section;
    const newSection = {
        id,
        pageId: selectPageId,
        type,
        globalSectionId,
        globalSectionName,
        deleted,
        pageIdOrigin
    };
    return mergePageSection({ state, selectIndex, selectPageId, sections: [newSection] });
}

function mergeSelectPageSectionsList({ state, selectIndex, selectPageId, sections }) {
    const insertSection = sections.map(section => {
        return {
            ...section,
            pageId: selectPageId
        };
    });
    return mergePageSection({ state, selectIndex, selectPageId, sections: insertSection });
}

export function mergePageSection({ state, selectIndex, selectPageId, sections }) {
    const pageSections = getPageSections(state, selectPageId);

    const newPageSections = [
        ...pageSections.slice(0, selectIndex),
        ...sections,
        ...pageSections.slice(selectIndex)
    ].map((section, index) => {
        return { ...section, seq: index + 1 };
    });
    return newPageSections;
}

export function getPageSections(state, selectPageId) {
    return _sortBy(
        state.filter(section => section.pageId === selectPageId),
        'seq'
    );
}

export function assignSectionId(section, sectionTemp = '', newSectionId = '', keyName = 'id') {
    const id = section[keyName];
    if (sectionTemp && newSectionId && id === sectionTemp) {
        return { ...section, [keyName]: newSectionId };
    }
    return section;
}

export function addSection(sectionData, selectPageId, selectSectionIndex) {
    return {
        type: ADD_SECTION,
        payload: {
            section: sectionData,
            selectPageId: selectPageId,
            selectIndex: selectSectionIndex
        }
    };
}

export function deleteSection(sectionId) {
    return {
        type: DELETE_SECTION,
        payload: { sectionId }
    };
}

function forceDeleteSection(sectionId) {
    return {
        type: FORCE_DELETE_SECTION,
        payload: { sectionId }
    };
}

export function addGlobalSectionSection(datas, selectPageId, selectSectionIndex) {
    return {
        type: ADD_GlobalSection_SECTION,
        payload: {
            sections: datas,
            selectPageId: selectPageId,
            selectIndex: selectSectionIndex
        }
    };
}

export function updateSectionType(type, selectId) {
    return {
        type: UPDATE_SECTION_TYPE,
        payload: {
            newType: type,
            selectId
        }
    };
}

function addMoveFlag(sectionId, pageId) {
    return {
        type: ADD_MOVE_FLAG,
        payload: {
            sectionId,
            pageId
        }
    };
}

export function pasteCutSection(index) {
    return (dispatch, getState) => {
        const {
            flag: { cutSectionId, selectPageId },
            sections
        } = getState();

        const addSectionData = sections.find(section => section.id === cutSectionId);
        const { pageId: originPageId, seq } = addSectionData;

        if (originPageId === selectPageId && index > seq - 1) {
            index -= 1;
        }

        dispatch(forceDeleteSection(cutSectionId));
        dispatch(addSection(addSectionData, selectPageId, index));
        dispatch(addMoveFlag(cutSectionId, originPageId));
        dispatch(resetCutSectionId());
    };
}

export function converCommonSection(sectionId) {
    return {
        type: CONVERT_COMMON_SECTION,
        payload: { sectionId }
    };
}

export function updateTempIdSection(sections = {}, pages = {}) {
    return {
        type: UPDATE_TEMPID_SECTION,
        payload: {
            mapSections: sections,
            mapPages: pages
        }
    };
}

export function convertGlobalSection(sectionId, globalSectionId, globalSectionName) {
    return {
        type: CONVERT_GlobalSection_SECTION,
        payload: {
            sectionId,
            globalSectionId,
            globalSectionName
        }
    };
}

export function convertGlobalSection2CommonSection(sectionId) {
    return {
        type: CONVERT_GlobalSection_SECTION,
        payload: {
            sectionId,
            globalSectionId: null,
            globalSectionName: ''
        }
    };
}

export function filterDuplicateData(originData, insertData) {
    return originData.filter(data => !insertData.find(newData => data.id === newData.id));
}

export function deletedGlobalSection(id, name) {
    return async (dispatch, getState) => {
        const {
            sections,
            sponsor: { id: sponsorId }
        } = getState();

        const deletedGlobalSection = sections.find(section => section.globalSectionId === id);
        const payload = {
            globalSectionId: id,
            name,
            deleted: 1
        };
        try {
            // 打 API 刪除 Sponsor 的常用欄位
            await updateGlobalSectionData({ data: payload }, sponsorId);

            if (deletedGlobalSection) {
                // 把 redux 的常用欄位轉成一般欄位
                dispatch(convertGlobalSection2CommonSection(deletedGlobalSection.id));
            }
            setSuccess(i18n.t('form.delete_success'));
        } catch (err) {
            console.error(err);
            setFailed(i18n.t('form.delete_failed'));
        }
    };
}

export function updatedGlobalSection(globalSectionId, globalSectionName) {
    return async (dispatch, getState) => {
        const {
            sections,
            sponsor: { id: sponsorId }
        } = getState();

        const shouldUpdateGlobalSection = sections.find(
            section => section.globalSectionId === globalSectionId
        );
        const payload = {
            globalSectionId,
            name: globalSectionName,
            deleted: 0
        };
        try {
            // 打 API 更新 Sponsor 的常用欄位
            await updateGlobalSectionData({ data: payload }, sponsorId);

            if (shouldUpdateGlobalSection) {
                // 把 redux 的常用欄位轉成一般欄位
                dispatch(
                    convertGlobalSection(
                        shouldUpdateGlobalSection.id,
                        globalSectionId,
                        globalSectionName
                    )
                );
            }
            setSuccess(i18n.t('form.update_success'));
        } catch (err) {
            console.error(err);
            setFailed(i18n.t('form.update_failed'));
        }
    };
}
